export const sxFlex1 = {
  flex: 1,
};

export const sxMR1 = {
  mr: 1,
};
